(function(root, unasigned) {
  root.md.diagnosis = root.md.diagnosis || {};
  var ns = root.md.diagnosis.diagnosis = root.md.diagnosis.diagnosis || {};
  
  ns.Validation = function($section){
    this.Evt = $({});
    this.$section = $section;
    this.$target  = $section.find(".js-story-input, .js-story-select");
    this.$savingsElement = $section.find("#savings");
    this.$startInvestmentElement = $section.find("#startInvestment");
    this.INDEX_START_INVESTMENT = 3;
  };
  
  ns.Validation.prototype.validateInput = function(index, val){
    var max = this.$target.eq(index).data("maximum");
    var min = this.$target.eq(index).data("minimum");
    var pattern = this.$target.eq(index).attr("pattern");
    var isPattern = !val.match("[^" + pattern+ "]");
    var isValue = (!!+val || parseInt(val,10) === 0);
    var isInMax = ( val <= max );
    var isInMin = ( val >= min );
    // return ( +val && min <= val && val <= max );
    return {
      index  : index,
      value  : val,
      isValid: (isPattern && isValue && isInMin && isInMax),
      errorid: (!isPattern | !isValue ? 0 : !isInMin ? 1 : !isInMax ? 2 : null),
    };
  };
  
  ns.Validation.prototype.validateSelect = function(index, val){
    // return !!val;
    return {
      index  : index,
      value  : val,
      isValid: !!val,
      errorid: null
    };
  };

  ns.Validation.prototype.validateInputStartInvestment = function(index, val){
    var minimumInvestment = this.$startInvestmentElement.data('minimum-investment');
    var startInvestment = parseInt(this.$startInvestmentElement.val(),10) * 10000;
    var isValidStartInvestment = (startInvestment >= minimumInvestment);

    return {
      index   : index,
      value   : val,
      isValid : isValidStartInvestment,
      errorid : (!isValidStartInvestment ? 4 : null)
    };
  };
  
  ns.Validation.prototype.validate = function(index, value){
    var element = this.$target.get(index);
    var tag = this.checkTag(element);
    var result;
    
    if (tag.isInput) {
      result = this.validateInput(index, value);
    }
    else if (tag.isSelect) {
      result = this.validateSelect(index, value);
    }

    if (index===this.INDEX_START_INVESTMENT && result.isValid===true) {
      result = this.validateInputStartInvestment(index, value);
    }

    return result;
  };
  
  ns.Validation.prototype.validateAll = function(){
    var that = this;
    var skipLength = 0;
    var invalidIndex;
    var resultFirst;
    var invalidIndexList = [];
    var resultList = [];
    this.$target.each(function(index, element){
      var value = element.value;
      var relatedLength = that.checkRelatedSection(index, value);
      var resultTmp = that.validate(index, value);
      var isValidTmp = resultTmp.isValid;
      resultList.push(resultTmp);
      
      if (!isValidTmp && !skipLength) {
        invalidIndexList.push(index);
      }
      if (skipLength) {
        skipLength--;
      }
      if (relatedLength) {
        skipLength = relatedLength;
      }
    });
    invalidIndex = invalidIndexList[0];
    resultFirst  = resultList[invalidIndex];
    return {
      isValid         : (!invalidIndex && invalidIndex !== 0),
      invalidIndex    : invalidIndex,
      resultFirst     : resultFirst,
      invalidIndexList: invalidIndexList,
      resultList      : resultList,
    };
  };
  
  ns.Validation.prototype.checkRelatedSection = function(index, value){
    if (!value) var value = this.$target.eq(index).val();
    var relatedSectionLength = this.$target.eq(index).data("related-section-length");
    var triggerValue = this.$target.eq(index).data("trigger-value");
    var shouldHideRelatedSection = (value == triggerValue);
    if (shouldHideRelatedSection) return relatedSectionLength;
    return false;
  };
  
  ns.Validation.prototype.checkTag = function(element){
    var tagname  = element.tagName.toLowerCase();
    var isInput  = (tagname === "input");
    var isSelect = (tagname === "select");
    return {
      tagname  : tagname,
      isInput  : isInput,
      isSelect : isSelect,
    };
  };
  
})(this);
